import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/chevronLeft.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-34a0412c")

_pushScopeId("data-v-34a0412c")
const _hoisted_1 = { class: "genericPadding hasHeader hasFooter bgWhite" }
const _hoisted_2 = { class: "header withShadow d-flex aling-items-center justify-content-between py-4" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = { class: "fs_12 greyBlue" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "sideContainer" }, null, -1)
const _hoisted_6 = {
  key: 0,
  class: "no_content_search"
}
const _hoisted_7 = { class: "descriptionContainer" }
const _hoisted_8 = { class: "info text-center" }
const _hoisted_9 = { class: "text-center mb-3 greyBlue" }
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "descriptionContainer" }
const _hoisted_13 = { class: "info text-center" }
const _hoisted_14 = { class: "greyBlue" }
const _hoisted_15 = { class: "scrollable_div" }
const _hoisted_16 = { class: "footerButtonContainer" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_google_autocomplete_get_results = _resolveComponent("google-autocomplete-get-results")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "sideContainer",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
      }, [
        _hoisted_3
      ]),
      _createVNode("span", _hoisted_4, _toDisplayString(_ctx.addressTitle), 1),
      _hoisted_5
    ]),
    (!_ctx.localSearchText)
      ? (_openBlock(), _createBlock("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              _createVNode("h5", _hoisted_9, [
                _createVNode("span", null, _toDisplayString(_ctx.addressQuestion), 1)
              ]),
              _createVNode("span", _hoisted_10, [
                _createVNode(_component_localized_text, {
                  class: "fs_13 grey",
                  localizedKey: "app_iniziaascrivereilnomedellaregione",
                  text: "Inizia a scrivere il nome della Regione, Provincia o Comune e scegli tra i suggerimenti"
                })
              ])
            ])
          ])
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_11, [
          _createVNode("div", _hoisted_12, [
            _createVNode("div", _hoisted_13, [
              _createVNode("h5", _hoisted_14, [
                _createVNode("span", null, _toDisplayString(_ctx.addressQuestion), 1)
              ])
            ])
          ]),
          _createVNode("div", _hoisted_15, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.provinceList, (city, index) => {
              return (_openBlock(), _createBlock("div", {
                class: "city_tab",
                key: index,
                onClick: ($event: any) => (_ctx.searchCityLocation(city))
              }, [
                _createVNode("span", null, _toDisplayString(city.description), 1)
              ], 8, ["onClick"]))
            }), 128))
          ])
        ])),
    _createVNode("div", _hoisted_16, [
      _createVNode(_component_google_autocomplete_get_results, {
        inputClass: 'genericInput',
        onChangeAddress: _ctx.changeAddress,
        placeholderText: _ctx.placeholderText,
        value: _ctx.localSearchText,
        onInput: _ctx.emitText
      }, null, 8, ["onChangeAddress", "placeholderText", "value", "onInput"])
    ])
  ]))
})